import { appConfig } from '../config/app';
import { IInvite, IInviteVerify } from '../types';
import { ApiClient } from './ApiClient';

export const Invites = {
  verify: (inviteId: string) => ApiClient.get<IInviteVerify>(`${appConfig.API_BASE_URL}/v1/invites/${inviteId}/verify`),
  show: (inviteId: string) => ApiClient.get<IInvite>(`${appConfig.API_BASE_URL}/v1/invites/${inviteId}`),
  accept: (inviteId: string) => ApiClient.put<IInvite>(`${appConfig.API_BASE_URL}/v1/invites/${inviteId}/accept`, { status: 'accept' }),
};
